module.exports = __webpack_public_path__ + "img/bottom.89f4ad63.png";